import script from "./Trigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trigger.vue?vue&type=script&setup=true&lang=ts"

export default script